<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="代祭预约订单"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-tabs
      sticky
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
    >
      <van-tab title="全部">
        <router-link to="/BookingOrderDetails" class="book-order-list" v-for="item in 5" :key="item.id">
          <van-cell>
            <div class="book-order-hd">
              <div class="code">订单编号: APP202006111125201676998626</div>
              <div class="status">待付款</div>
            </div>
            <div class="des van-multi-ellipsis--l2">委托人dddd于2020年06月11日代祭给xxx!</div>
          </van-cell>
          <van-cell>
            <div class="goods-list">
              <div class="hd">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
              </div>
              <div class="bd">
                <div class="title"><h2 class="name">清明节鲜花祭祀黄白菊</h2><span class="num">x1</span></div>
                <div class="price">￥119.0</div>
              </div>
            </div>
          </van-cell>
          <van-cell class="goods-list-ft">
            <template>
              <van-button size="small">取消</van-button>
              <van-button size="small" color="orange">付款</van-button>
            </template>
            <template #title>
              <div class="totalPrice">实付:￥119.0</div>
            </template>
          </van-cell>
        </router-link>
      </van-tab>
      <van-tab title="待付款">
        <van-empty description="暂无" />
      </van-tab>
      <van-tab title="已完成">
        <van-empty description="暂无" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.book-order-list{
  margin-top: 8px;
  display: block;
}
.book-order-hd{
  display: flex;
  align-items: center;
}
.book-order-list .code{
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.book-order-list .status{
  font-size: 15px;
  color: crimson;
  margin-left: 15px;
}
.book-order-list .des{
  font-size: 14px;
  color: #222;
  margin-top: 4px;
}
.goods-list{
  display: flex;
  align-items: center;
}
.goods-list>.hd{
  width: 50px;
  height: 50px;
  margin-right: 12px;
}
.goods-list>.bd{
  flex: 1;
  overflow: hidden;
}
.goods-list>.bd .title{
  display: flex;
  align-items: center;
  overflow: hidden;
}
.goods-list>.bd .title .name{
  font-size: 14px;
  color: #555;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.goods-list>.bd .title .num{
  margin-left: 10px;
  font-size: 10px;
  color: #999;
}
.goods-list>.bd .price{
  font-size: 12px;
  color: crimson;
  margin-top: 2px;
}
.goods-list-ft .van-button{
  margin-left: 10px;
}
.goods-list-ft .totalPrice{
  font-size: 13px;
  color: #666;
}
</style>
